<template>
    <BreadCrumb PageTitle="Ajouter un document" />
    <AddDocument/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddDocument from "../../components/Document/AddDocument.vue"
  
    export default defineComponent({
      name: "AddDocumentPage",
      components: {
        BreadCrumb,
        AddDocument,
      },
    });
  </script>